import { useTranslation } from 'react-i18next';

export const useLocalizedMonths = (): string[] => {
  const { t } = useTranslation('common');

  const months = [
    t('january'),
    t('february'),
    t('march'),
    t('april'),
    t('may'),
    t('june'),
    t('july'),
    t('august'),
    t('september'),
    t('october'),
    t('november'),
    t('december'),
  ];

  return months;
};
